import * as types from "./types";
import { combineReducers } from "redux";

function dataSaved(state = { status: false, msg: "" }, { type, payload }) {
  return type === types.DATA_SAVED
    ? payload
    : type === types.RESET_DATA_SAVED
      ? { status: false, msg: "" }
      : state;
}

function tareasDeVenta(state = [], { type, payload }) {
  return type === types.ADDED_TAREA_DE_VENTA
    ? [
        ...state.filter(
          ({ id, idColegio }) =>
            id !== payload.id && idColegio === payload.idColegio
        ),
        payload
      ]
    : type === types.REMOVED_TAREA_DE_VENTA
      ? state.filter(({ id }) => id !== payload.id)
      : type === types.CHANGED_TAREA_DE_VENTA
        ? state.map(item => (item.id === payload.id ? payload : item))
        : type === types.LIMPIAR_TAREAS_DE_VENTA
          ? []
          : state;
}

const reducer = combineReducers({
  dataSaved,
  tareasDeVenta
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventasTareas/reducers.js